import { GroupConfigurationCategory } from '@/modules/group/modules/groups/domain/models/GroupConfigurationCategory'
import { MentionedType } from '@/shared/types/post/enums/MentionedType'
import { PersonaInfoSummary } from '@/therapist/pages/tasks/types/Task'

import { TaskStatus } from '../../../types/tasks/task-status'
import { axios, Response } from '../index'

export type UserInfo = {
  username: string
  userId: string
  avatarUrl: string
  activity: 'green' | 'gray' | 'red'
  personId?: string
  groupCategory?: GroupConfigurationCategory
  postEdit?: 'CREATOR_ONLY' | 'ANYONE'
  avatarName: string
}

export type MentionInfo = {
  personaId: string
  fullName: string
  avatarName: string
  avatarUrl: string
  id: string
}

export type Task = {
  id: number
  title: number
}

export type PostMention = {
  id: string
  type: MentionedType
  template: MentionInfo
}

export type Reaction = {
  reactionId: number
  type: string
  author: UserInfo
  alike: boolean
  postId: number
}
export type Comment = {
  id?: number | string
  idPostComment?: number
  content: string
  author?: UserInfo
  publishedAt: string
  createdAt: string
}

export type PostFile = {
  fileName: string
  contentType: string
  type: string
  fileUrl: string
}

export type PostTask = {
  id: string
  title: string
  description: string
  taskStatus: TaskStatus
  membersOfTasks?: MemberOfTask[]
}

export type MemberOfTask = {
  taskId: string
  userId: string
  username: string
  avatarUrl: string
  avatarName: string
}

export type Poll = {
  id: string
  multipleAnswers: boolean
  options: {
    id: string
    name: string
    vows: {
      amount: number
      persona: {
        userId: string
        username: string
        avatarUrl: string
      }[]
    }
  }[]
}

export type UserGroups = {
  id: string
  name: string
}

export type PostView = {
  id: string
  postId: number
  viewingDate: string
  personaInfoSummary: PersonaInfoSummary
}

export type Post = {
  id: number
  owner: UserInfo
  pinned: boolean
  content: string
  comments: Comment[]
  reactions: Reaction[]
  files: PostFile[]
  postTasks: PostTask[]
  important: boolean
  mentions: PostMention[]
  publishedBy: UserInfo
  publishedAt: string
  likesCount: number
  tasksCount: number
  commentsCount: number
  likedByLoggedUser: boolean
  poll: Poll
  userGroups: UserGroups[]
  personUpdatedAt: PersonaInfoSummary
  sharedBy?: PersonaInfoSummary
  updatedAt: Date
  views: PostView[]
  silentlyViewed: boolean
}

const getPostById = (postId: number | string): Response<Post> => {
  return axios.get(`/v2/posts/${postId}`)
}

export default getPostById
